"use client"

import { useEffect, useState } from "react"
import { CategorySelect } from "@/components/shared/header/category-select"
import { CartSheet } from "@/components/shared/header/navbar-components/cart-sheet"
import UserMenu from "@/components/shared/header/navbar-components/user-menu"
import { SearchProducts } from "@/components/shared/header/search-products"

const SITE_HEADER_ID = "site-header"

export function StickyHeader() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const headerElement = document.getElementById(SITE_HEADER_ID)
    if (!headerElement) return

    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(!entry.isIntersecting)
    })

    observer.observe(headerElement)
    return () => observer.disconnect()
  }, [])

  if (!isVisible) return null

  return (
    <div className='fixed inset-x-0 top-0 z-999 hidden border-b bg-background py-2 md:block'>
      <div className='mx-auto flex h-16 w-full max-w-6xl items-center justify-between gap-4 px-6'>
        <div className='shrink-0'>
          <CategorySelect />
        </div>

        <div className='flex w-full max-w-150 flex-1 justify-center'>
          <SearchProducts />
        </div>

        <div className='flex shrink-0 items-center gap-2'>
          <CartSheet />
          <UserMenu />
        </div>
      </div>
    </div>
  )
}
